<template>
  <div class="sign-in-container">
    <div
      id="firebaseui-auth-container"
      ref="firebaseui-auth-container"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { authCompat } from "@/firebase"
import { authSettings } from "@/firebase/config"
import firebase from 'firebase/compat/app'
import * as firebaseui from "firebaseui"
import "firebaseui/dist/firebaseui.css"

let ui: firebaseui.auth.AuthUI | null = null
const captchaVerified = ref(false)

// Глобальная функция для обработки верификации reCAPTCHA
// @ts-ignore
window.onCaptchaVerify = () => {
  console.log('reCAPTCHA verified')
  captchaVerified.value = true
}

onMounted(() => {
  const uiConfig = {
    ...authSettings,
    signInOptions: [
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        defaultCountry: 'ME',
        whitelistedCountries: ['ME'],
        loginHint: '+382',
        recaptchaParameters: {
          size: 'invisible',
          badge: 'bottomleft' // Возвращаем к исходному значению для лучшей совместимости с мобильными устройствами
        }
      }
    ],
    // Предотвращаем перезагрузку страницы
    signInFlow: 'popup',
    // Отключаем редирект после аутентификации
    signInSuccessUrl: undefined,
    callbacks: {
      signInSuccessWithAuthResult: (authResult: any) => {
        console.log('Auth result:', authResult)
        // Возвращаем false, чтобы предотвратить перенаправление
        return false
      },
      signInFailure: (error: firebaseui.auth.AuthUIError) => {
        console.error('Auth error:', error)
        // Обрабатываем ошибки аутентификации
        return Promise.resolve()
      },
      // Добавляем обработчик для предотвращения перезагрузки на мобильных устройствах
      uiShown: () => {
        // Находим все формы в контейнере FirebaseUI
        const forms = document.querySelectorAll('#firebaseui-auth-container form')
        forms.forEach(form => {
          form.addEventListener('submit', (e) => {
            // Предотвращаем стандартную отправку формы
            e.preventDefault()
          })
        })
      }
    }
  }

  ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(authCompat)
  ui.start("#firebaseui-auth-container", uiConfig)
})

onUnmounted(() => {
  if (ui) {
    ui.delete()
  }
})
</script>

<style scoped>
.sign-in-container {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}

:deep(.firebaseui-container) {
  max-width: 100%;
}

:deep(.firebaseui-card-content) {
  padding: 16px;
}

/* Стили для улучшения мобильной совместимости */
:deep(.grecaptcha-badge) {
  bottom: 10px !important;
  right: 10px !important;
  opacity: 0.8;
}

/* Стили для мобильных устройств */
@media (max-width: 768px) {
  :deep(.firebaseui-container) {
    margin: 0;
  }
  
  :deep(.firebaseui-card-content) {
    padding: 10px;
  }

  :deep(.firebaseui-input, .firebaseui-button) {
    font-size: 16px; /* Предотвращает масштабирование на iOS */
  }
}
</style>
